// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1EgWW","title":"styles_title__29KBI"};